import { Capacitor } from '@capacitor/core';
import { PasswordAutofill } from '@capawesome/capacitor-password-autofill';

export const AUTH_DOMAIN = 'keep.cruisingalong.com';

export interface SaveCredentialOptions {
  email: string;
  password: string;
  displayName?: string;
}

/**
 * Prompts the user to save credentials in either:
 * - Native mobile credential store (Google Password Manager on Android, iCloud Keychain on iOS)
 * - Browser password manager (Chrome / Edge / supported browsers via Credential Management API)
 */
export const saveCredentials = async ({ email, password, displayName }: SaveCredentialOptions): Promise<void> => {
  if (!email || !password) return;

  try {
    if (Capacitor.isNativePlatform()) {
      // Native iOS (iCloud Keychain) & Android (Google Password Manager)
      await PasswordAutofill.savePassword({
        username: email,
        password,
        domain: AUTH_DOMAIN,
      });
    } else if (typeof window !== 'undefined' && 'PasswordCredential' in window && navigator.credentials?.store) {
      // Web browsers (Chromium / Edge / W3C standard)
      const cred = new (window as any).PasswordCredential({
        id: email,
        password,
        name: displayName || email,
      });
      await navigator.credentials.store(cred);
    }
  } catch (error) {
    // Non-blocking: user cancellation or device lack of credential provider is safe to ignore
    console.debug('[CredentialManager] Credential save skipped or dismissed:', error);
  }
};
